import { useMemo } from 'react'
import { SimpleGrid, Box, Text } from '@chakra-ui/react';
import ProfileCard from '../districtProfile/ProfileCard'
import { DensityHeatmap } from '../shared/DensityHeatmap'
import { ShareBars } from './ShareBars'
import { useGeoUnits, useGeoLiveMetrics } from '../../hooks/useGeoAnalytics'
import { buildDensityPoints, toFilterGroupRequests } from '../guidedList/reviewSpec'
import type { ListOverview } from '../../types/contactList'

export function GeographyPanel({ overview }: { overview: ListOverview }) {
  const state = overview.geography.dominantState
  const hasFilters = overview.filterGroups.length > 0
  const precinctUnits = useGeoUnits(state ? { type: 'precinct', state } : null)
  const live = useGeoLiveMetrics(
    state && hasFilters ? { unitType: 'precinct', state, filterGroups: toFilterGroupRequests(overview.filterGroups) } : null,
  )
  const points = useMemo(
    () => (precinctUnits.data && live.data ? buildDensityPoints(precinctUnits.data, live.data) : null),
    [precinctUnits.data, live.data],
  )
  const canMap = !!state && hasFilters

  return (
    <ProfileCard eyebrow="Geography" title="Where they are">
      <SimpleGrid columns={{ base: 1, md: 2 }} gap={6} mt={3}>
        <Box>
          {canMap ? (
            <DensityHeatmap points={points} caption="Household density by precinct (k≥10 floored). Illustrative texture, not a pin-map." height="220px" />
          ) : (
            <Box h="220px" borderWidth="1px" borderRadius="lg" bg="gray.50" display="flex" alignItems="center" justifyContent="center" p={4}>
              <Text fontSize="sm" color="gray.400" textAlign="center">
                Density map unavailable for this list (needs a location-based universe).
              </Text>
            </Box>
          )}
        </Box>
        <Box>
          <Text fontSize="sm" fontWeight="medium" mb={2}>Top localities</Text>
          <ShareBars rows={overview.geography.topLocalities} />
          <Text fontSize="sm" fontWeight="medium" mt={4} mb={2}>Top districts</Text>
          <ShareBars rows={overview.geography.topDistricts} color="purple" />
        </Box>
      </SimpleGrid>
    </ProfileCard>
  );
}
